import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickResult from '@/components/brick_result.vue'
import SummaryResult from '@/components/summary_result.vue'
import Vue from 'vue'

Vue.component('SummaryResult', SummaryResult)

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-download', 'text-blue']
infos.front_classes = ['fas', 'fa-download', 'text-white']
infos.name = 'result'
infos.associated_class_name = 'AutomlResult'
infos.editing_component_name = 'BrickResult'
infos.editing_component = BrickResult
infos.summary_component_name = 'SummaryResult'
infos.summary_component = SummaryResult
infos.descriptions = {
	en: {
		short_tooltip_description: 'Result',
		full_tooltip_description: 'Outputs a downloadable file with results',
		navbar_name: 'Result',
	},
	fr: {
		short_tooltip_description: 'Résultat',
		full_tooltip_description:
			"Téléchargement des résultats sous la forme d'un fichier csv",
		navbar_name: 'Résultat',
	},
}
// infos.short_tooltip_description = 'result_short_tooltip'
// infos.full_tooltip_description = 'result_full_tooltip'
// infos.navbar_name = 'result_navbar'
infos.background_color = 'green'

brick_registerer(infos)
